import { datadogLogs } from "@datadog/browser-logs";
export default function initDatadogLogging({ clientToken, service, enabled = false, sampleRate = 100, forwardErrorsToLogs = true, ...otherOptions }) {
    if (enabled) {
        datadogLogs.init({
            clientToken,
            service,
            sampleRate,
            forwardErrorsToLogs,
            ...otherOptions,
        });
    }
}
//# sourceMappingURL=initDatadogLogging.js.map